export default __webpack_public_path__ + "static/media/resume.3b4311c3.pdf";